import { Component, OnInit } from '@angular/core';
import { Edition } from '../models/edition.model';
import { EditionService } from '../services/edition.service';

@Component({
  selector: 'app-archives',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.css']
})
export class ArchivesComponent implements OnInit {

  editions: Edition[] = [];

  constructor(private editionService: EditionService) { }

  ngOnInit(): void {
    this.editionService.getEditions().subscribe(data => {
      this.editions = data;
    });
  }

  estVideo(url: string | undefined | null): boolean {
    if (!url) return false;
    return /\.(mp4|webm|mov|avi)(\?.*)?$/i.test(url);
  }
}
